import React from 'react';
import { FormField, FormSelect, FormSection, FormCheckbox } from '../../../shared/FormComponents';
import { STATE_OPTIONS, TOOLTIPS } from '../../../shared/constants';

const BasicInfoSection = ({ register, errors, watch }) => {
  const isActive = watch('isActive', true); // Default to true if not set

  return (
    <FormSection title="Basic Information">
      <div className="grid grid-cols-1 gap-4">
        {/* Row 1: Income Name | Employer */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField
            label="Income Name *"
            name="name"
            register={register}
            error={errors.name}
            tooltip={TOOLTIPS.name}
            placeholder="Contract Work"
          />
          <FormField
            label="Employer"
            name="employer"
            register={register}
            error={errors.employer}
            tooltip="Enter the name of the employer or company you're contracting with"
            placeholder="Acme Corp"
          />
        </div>

        {/* Row 2: Start Date | End Date | Contract is Active */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <FormField
            label="Start Date *"
            name="startDate"
            type="date"
            register={register}
            error={errors.startDate}
            tooltip={TOOLTIPS.startDate}
            max={new Date().toISOString().split('T')[0]}
          />
          <FormField
            label="End Date"
            name="endDate"
            type="date"
            register={register}
            error={errors.endDate}
            tooltip={TOOLTIPS.endDate}
            disabled={isActive}
            min={watch('startDate')}
          />
          <div>
            <FormCheckbox
              label="Contract Status"
              name="isActive"
              register={register}
              error={errors.isActive}
              tooltip={TOOLTIPS.isActive}
              defaultChecked={false}
              labelAbove={true}
              className="h-[30px] w-[30px]"
            />
          </div>
        </div>
        
        {/* Row 3: State */}
        <div>
          <FormSelect
            label="State *"
            name="state"
            options={STATE_OPTIONS}
            register={register}
            error={errors.state}
            tooltip={TOOLTIPS.state}
            required={true}
            defaultValue=""
          />
        </div>
      </div>
    </FormSection>
  );
};

export default BasicInfoSection; 